import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './styles.scss';
import { CONTACT, TELEGRAM } from '../../lib/contact';

LeadForm.propTypes = {
    /** Telegram xabarida ko'rinadi — qaysi sahifadan kelgani */
    source: PropTypes.string,
    /** 'full' — xabar maydoni bilan, 'compact' — faqat ism va telefon */
    variant: PropTypes.oneOf(['full', 'compact']),
    /** Yuborish tugmasi matni */
    submitLabel: PropTypes.string,
};

/**
 * Ariza formasi — butun sayt bo'ylab yagona implementatsiya.
 * Ma'lumot to'g'ridan-to'g'ri Telegram guruhiga tushadi.
 */
function LeadForm({ source = '', variant = 'full', submitLabel }) {
    const { t } = useTranslation();

    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState(null); // 'ok' | 'error' | null

    async function handleSubmit(e) {
        e.preventDefault();

        if (!name.trim() || !phone.trim()) {
            setStatus('required');
            return;
        }

        const text = [
            '<b>Innobek — yangi ariza</b>',
            `Ism: ${name}`,
            `Telefon: ${phone}`,
            message ? `Xabar: ${message}` : null,
            source ? `Xizmat: ${source}` : null,
            `Sahifa: ${window.location.href}`,
        ].filter(Boolean).join('\n');

        setSending(true);
        setStatus(null);

        try {
            const res = await fetch(`https://api.telegram.org/bot${TELEGRAM.token}/sendMessage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ chat_id: TELEGRAM.chatId, parse_mode: 'HTML', text }),
            });

            const data = await res.json();
            if (!data.ok) throw new Error(data.description || 'Telegram error');

            setName('');
            setPhone('');
            setMessage('');
            setStatus('ok');
        } catch (err) {
            console.error('Telegram sendMessage failed:', err);
            setStatus('error');
        } finally {
            setSending(false);
        }
    }

    return (
        <form className={`lead-form lead-form--${variant}`} onSubmit={handleSubmit} noValidate>
            <div className="lead-form__row">
                <input
                    type="text"
                    name="name"
                    autoComplete="name"
                    placeholder={t('name')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    aria-label={t('name')}
                />
                <input
                    type="tel"
                    name="phone"
                    autoComplete="tel"
                    placeholder={t('phone')}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    aria-label={t('phone')}
                />
            </div>

            {variant === 'full' ? (
                <textarea
                    name="message"
                    rows="4"
                    placeholder={t('desc')}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    aria-label={t('desc')}
                />
            ) : null}

            <button className="tf-button btn-effect" type="submit" disabled={sending}>
                <span className="effect">
                    {sending ? t('sending') : (submitLabel || t('send'))}
                </span>
            </button>

            <p className="lead-form__note">
                {t('form-note')} <a href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>
            </p>

            {status ? (
                <p
                    className={`lead-form__status is-${status === 'ok' ? 'ok' : 'error'}`}
                    role="status"
                    aria-live="polite"
                >
                    {status === 'ok' && t('form-success')}
                    {status === 'error' && t('form-error')}
                    {status === 'required' && t('form-required')}
                </p>
            ) : null}
        </form>
    );
}

export default LeadForm;
